import { createTheme } from "@mui/material/styles";

const MUI_THEME = createTheme({
  palette: {
    primary: {
      main: "#800000", // Yellow
      light: "#800000", // Light Yellow
      bgLight: "#FFF8E1", // Very light yellow background
    },
    secondary: {
      main: "#FF00FF", // Magenta
      light: "#fff", // Light Magenta
    },
    customColor: {
      dustyGray: "#999999",
      tundora: "#4D4D4D",
      scorpion: "#5D5D5D",
      blueRomance: "#CCF6D7", // Light Green
      malachite: "#02BB34", // Green
      alto: "#DBDBDB", // Light Gray (0.2)
      gray: "#888888", // Gray
      tequila: "#FFE7CB", // Light Orange
      tahitiGold: "#EA7E03", // Orange
      palePink: "#FFCBCB", // Light Pink
      darkRed: "#800000", // Deep Maroon (Replaced color)
      moonRaker: "#D1E0F7", // Light Blue
    },
  },

  typography: {
    fontFamily: ["Poppins", "sans-serif"].join(","),
    color: "#5D5D5D", // Dark Gray
    h5: {
      color: "#5D5D5D",
    },
    body1: {
      color: "#5D5D5D",
    },
  },

  shadows: ["0px 0px 6px 0px #00000040", "0px 0px 6px 0px #00000040"],

  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: "Poppins",
          textTransform: "capitalize",
          borderRadius: "8px",
          width: "100%",
          height: "100%",
          boxShadow: "none",
        },
        suspend_button: {
          border: "2px solid #800000", // Deep Maroon
          color: "#fff",
          fontSize: "1rem",
          backgroundColor: "#800000",
        },
        custom_outlined: {
          border: "2px solid #800000", // Yellow
          color: "#fff",
          fontSize: "1rem",
          backgroundColor: "#800000",
        },
        tab_button: {
          fontSize: "1rem",
          backgroundColor: "#ffffff",
          borderRadius: "8px",
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: "outlined",
      },
      styleOverrides: {
        root: {
          "&.MuiFormControl-root .MuiOutlinedInput-root .MuiInputBase-input": {
            padding: "12px 10px",
          },
          "& .MuiOutlinedInput-root": {
            borderRadius: "10px",
            "& .MuiOutlinedInput-notchedOutline": {
              border: `1px solid #800000`, // Deep Maroon
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              border: `1px solid #800000`, // Yellow
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              border: `1px solid #FF00FF`, // Magenta
            },
          },
          "& .MuiFormHelperText-root": {
            marginLeft: 0,
            marginTop: 0,
          },
          "& .Mui-disabled": {
            cursor: "not-allowed",
          },
        },
      },
    },
  },
});

export default MUI_THEME;
